import { render, staticRenderFns } from "./printreciept.vue?vue&type=template&id=f85115d8&"
import script from "./printreciept.vue?vue&type=script&lang=js&"
export * from "./printreciept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports